export default __webpack_public_path__ + "static/media/Download-s.eb7a5bd6.svg";